/**
 * Created by kevinqueeney on 08/09/2015.
 */
angular.module('qkr.inventory').factory('variantSortingService', [function() {
    const sortVariants = function(variants) {
        if (variants != null && variants.length > 0) {
            variants.sort((variantA, variantB) => variantA.priority - variantB.priority);

            const variantDetailsSortable = variants[0].variantDetails.length > 1;
            const canSortVariantDetailsByPriority = variantDetailsSortable ? canSortVariantDetailsOnPriority(variants) : false;

            if (variantDetailsSortable) {
                if (canSortVariantDetailsByPriority) {
                    sortVariantDetailsBasedOnPriority(variants);
                } else {
                    const alternationFrequencyRecordList = getAlternationFrequencyRecordListForVariantDetails(variants);
                    if (alternationFrequencyRecordList != null) {
                        // Get ordered list of variant labels from the alternationFrequencyRecordList
                        const variantDetailOrderList = getVariantDetailOrderListFromAlternationFrequencyRecordList(alternationFrequencyRecordList);
                        sortVariantsBasedOnVariantDetailOrder(variants, variantDetailOrderList);
                    }
                }
            }
        }
    };

    const sortVariantDetails = function(variantSetSummaries, variant) {
        const sortedVariantDetails = [];

        angular.forEach(variantSetSummaries, (variantSetSummary) => {
            for (let i = 0; i < variant.variantDetails.length; i++) {
                const variantDetail = variant.variantDetails[i];

                if (variantDetail.variantLabel == variantSetSummary.type) {
                    sortedVariantDetails.push(variantDetail);
                    break;
                }
            }
        });

        variant.variantDetails = sortedVariantDetails;
    };

    var canSortVariantDetailsOnPriority = function(variants) {
        // Check if the priority is intact
        const variantDetails = variants[0].variantDetails;
        let numZeroPriorityVariants = 0;

        for (let i = 0; i < variantDetails.length; i++) {
            if (variantDetails[i].priority == 0) {
                numZeroPriorityVariants++;
            }
        }

        if (numZeroPriorityVariants == variantDetails.length) {
            return false;
        }

        return true;
    };

    var sortVariantDetailsBasedOnPriority = function(variants) {
        angular.forEach(variants, (variant) => {
            variant.variantDetails.sort((variantDetailA, variantDetailB) => variantDetailA.priority - variantDetailB.priority);
        });
    };

    const sortVariantDetailsBasedOnVariantLabel = function(variants) {
        angular.forEach(variants, (variant) => {
            variant.variantDetails.sort((variantDetailA, variantDetailB) => {
                const variantLabelA = variantDetailA.variantLabel.toUpperCase();
                const variantLabelB = variantDetailB.variantLabel.toUpperCase();

                return (variantLabelA < variantLabelB) ? -1 : (variantLabelA > variantLabelB) ? 1 : 0;
            });
        });
    };

    var sortVariantsBasedOnVariantDetailOrder = function(variants, variantDetailOrderList) {
        angular.forEach(variants, (variant) => {
            const reorderList = [];
            angular.forEach(variantDetailOrderList, (variantDetailOrder) => {
                for (let index = 0; index < variant.variantDetails.length; index++) {
                    const variantDetail = variant.variantDetails[index];
                    if (variantDetailOrder == variantDetail.variantLabel) {
                        reorderList.push(index);
                        break;
                    }
                }
            });

            const sortedVariantDetails = [];

            for (let index = 0; index < reorderList.length; index++) {
                const sortedVariantDetail = variant.variantDetails[reorderList.indexOf(index)];
                sortedVariantDetail.priority = index;
                sortedVariantDetails.push(sortedVariantDetail);
            }

            variant.variantDetails = sortedVariantDetails;
        });
    };

    const createAlternationFrequencyRecord = function(variantDetail) {
        return {
            variantLabel: variantDetail.variantLabel,
            latestVariantValue: variantDetail.variantValue,
            alternationFrequency: 0
        };
    };

    const validateAlternationFrequencyRecordList = function(alternationFrequencyRecordList) {
        // If any of the alternation frequency values are equal it's not valid
        const uniqueAlternateFrequencyValueList = [];
        for (let i = 0; i < alternationFrequencyRecordList.length; i++) {
            const alternationFrequency = alternationFrequencyRecordList[i].alternationFrequency;
            if (uniqueAlternateFrequencyValueList.indexOf(alternationFrequency) == -1) {
                uniqueAlternateFrequencyValueList.push(alternationFrequency);
            } else {
                return false;
            }
        }

        if (uniqueAlternateFrequencyValueList.length > 0) {
            return true;
        }
        return false;
    };

    var getVariantDetailOrderListFromAlternationFrequencyRecordList = function(alternationFrequencyRecordList) {
        alternationFrequencyRecordList.sort((alternationFrequencyRecordA, alternationFrequencyRecordB) => alternationFrequencyRecordA.alternationFrequency - alternationFrequencyRecordB.alternationFrequency);

        const variantDetailOrderList = [];

        angular.forEach(alternationFrequencyRecordList, (alternationFrequencyRecord) => {
            variantDetailOrderList.push(alternationFrequencyRecord.variantLabel);
        });

        return variantDetailOrderList;
    };

    // Function returns true if attempt is successful, false if attempt fails
    var getAlternationFrequencyRecordListForVariantDetails = function(variants) {
        const copyOfVariants = angular.copy(variants);

        // Assume variant details are out of sync so sort variant details by variant label - alphabetically
        sortVariantDetailsBasedOnVariantLabel(copyOfVariants);

        // Detect true variant detail order.
        // Get the variantDetails and build a list to hold the ordinals
        const alternationFrequencyRecordList = [];

        // Build the alternation frequency records
        angular.forEach(copyOfVariants[0].variantDetails, (variantDetail) => {
            alternationFrequencyRecordList.push(createAlternationFrequencyRecord(variantDetail));
        });

        // As we go through the list, score each value based on whether it's changed from the last
        angular.forEach(copyOfVariants, (variant) => {
            angular.forEach(variant.variantDetails, (variantDetail, index) => {
                // Because the variantDetails are sorted, we can use the index to get at the correct alternationFrequencyRecord
                const alternationFrequencyRecord = alternationFrequencyRecordList[index];
                if (alternationFrequencyRecord.variantLabel != variantDetail.variantLabel) {
                    // Something has gone wrong, cannot sort using this method
                    return null;
                }

                if (variantDetail.variantValue != alternationFrequencyRecord.latestVariantValue) {
                    alternationFrequencyRecord.latestVariantValue = variantDetail.variantValue;
                    alternationFrequencyRecord.alternationFrequency++;
                }
            });
        });

        if (validateAlternationFrequencyRecordList(alternationFrequencyRecordList)) {
            return alternationFrequencyRecordList;
        }
        return null;
    };

    return {
        sortVariants(variants) {
            sortVariants(variants);
        },

        sortVariantDetails(variantSetSummaries, variant) {
            sortVariantDetails(variantSetSummaries, variant);
        },

        canSortVariantDetailsOnPriority(variants) {
            return canSortVariantDetailsOnPriority(variants);
        },

        sortVariantDetailsBasedOnPriority(variants) {
            sortVariantDetailsBasedOnPriority(variants);
        },

        sortVariantDetailsBasedOnVariantLabel(variants) {
            sortVariantDetailsBasedOnVariantLabel(variants);
        },

        sortVariantsBasedOnVariantDetailOrder(variants, variantDetailOrderList) {
            sortVariantsBasedOnVariantDetailOrder(variants, variantDetailOrderList);
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/inventory/services/variantSorting.services.js